export enum TrainingType {
  Induction = 'INDUCTION',
  Training = 'TRAINING',
  Outage = 'OUTAGE_ACCEPTANCE',
};
